import {URL} from './api';
import axios from 'axios';
import {parseStorage} from './functions'
import {helpBarAction} from './helpbarAction'

export const GET_AWARDS = 'GET_AWARDS'

export function awardsAction(data){
    return dispatch => {
        axios.get(URL + `/guest/ranks`,{
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function(res){
            dispatch({
                type: GET_AWARDS,
                data: res.data.results
            })                     
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/awardsAction.js